import { createSlice } from "@reduxjs/toolkit"

type ComplianceStateType = {
  complianceGroups: Array<any>
  selectedComplianceGroup: null | any

  complianceRegions: Array<any>
  selectedComplianceRegion: null | any

  complianceOffices: Array<any>
  selectedComplianceOffice: null | any

  complianceData: any
}

const initialState: ComplianceStateType = {
  complianceGroups: [],
  selectedComplianceGroup: null,

  complianceRegions: [],
  selectedComplianceRegion: null,

  complianceOffices: [],
  selectedComplianceOffice: null,

  complianceData: [],
}

const ComplianceSlice = createSlice({
  name: "compliance",
  initialState,
  reducers: {
    setComplianceGroupList: (state, action) => {
      state.complianceGroups = action.payload
    },
    setSelectedGroup: (state, action) => {
      state.selectedComplianceGroup = action.payload
    },
    setComplianceRegionList: (state, action) => {
      state.complianceRegions = action.payload
    },
    setSelectedRegion: (state, action) => {
      state.selectedComplianceRegion = action.payload
    },
    setComplianceOfficeList: (state, action) => {
      state.complianceOffices = action.payload
    },
    setSelectedOffices: (state, action) => {
      state.selectedComplianceOffice = action.payload
    },
    setComplianceData: (state, action) => {
      state.complianceData = action.payload
    },
  },
})

export default ComplianceSlice.reducer

export const {
  setComplianceGroupList,
  setSelectedGroup,
  setComplianceRegionList,
  setSelectedRegion,
  setComplianceOfficeList,
  setSelectedOffices,
  setComplianceData,
} = ComplianceSlice.actions
